export const formControlFocus = () => `
    input,
    select {
        border: 1px solid var(--container-background-trans);
    }

    input:focus,
    select:focus,
    textarea:focus,
    .dropdown-select__control.dropdown-select__control--is-focused,
    .react-datepicker__input-container button:focus,
    .react-datepicker__input-container input:focus,
    .react-datepicker__input-container > input:focus {
        background: var(--container-background-focus);
        border: 1px solid var(--container-border-focus);
    }

    .react-datepicker__input-container > input{
        border-radius: 0 var(--form-input-radius) var(--form-input-radius) 0 !important;
        height: 34px;
    }

    input,
    select {
        height: 34px;
    }
    
    .react-datepicker__input-container button:focus{
        height: 34px;
        padding-top: 3px;
        border-radius: var(--form-input-radius);
    }
    
    textarea:focus{
        padding-left: calc(0.75rem - 1px);
        padding-right: calc(0.75rem - 1px);
        padding-top: 7px;
       
    }
    
    .dropdown-select__control.dropdown-select__control--is-focused{
        .dropdown-select__placeholder{
            padding-left: calc(0.75rem - 1px);
            padding-right: calc(0.75rem - 1px);
            padding-bottom: 2px;
        }
        .dropdown-select__single-value{
            padding-left: calc(0.75rem - 1px);
            padding-right: calc(0.75rem - 1px);
        }
        input:Focus{
            padding-left: calc(0.75rem - 1px);
            padding-right: calc(0.75rem - 1px);
            padding-bottom: 5px;
        }
    }
    .react-datepicker__input-container button:focus{
        padding-left: 47px;
    }
`;
